import action from './action'

export default {
    getProducts(params) {
        return action.request('get_welcom_products',{query: JSON.stringify(params)})
    }
}
